<!-- v2017-11-27 -->

<template>
  <transition name="shared-modal">
    <div class="modal-mask" @click="$emit('close')">
      <div class="modal-wrapper">
        <div class="modal-container" :class="size" @click.stop>
          <i class="fa fa-times" @click="$emit('close')" v-if="!hideX"></i>
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "vue-ez-modal",
  props: ["size", "hideX"],
  mounted() {
    // document.ontouchmove = function (e) { e.preventDefault() }
    document.body.style.overflow = "hidden";
  },
  beforeDestroy() {
    // document.ontouchmove = function (e) { return true }
    document.body.style.overflow = null;
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/_global";

.fa-times {
  border-bottom: none;
  color: $gray-400;
  cursor: pointer;
  vertical-align: text-top;
  float: right;
  margin: 0;
  font-size: 1.25em;
  z-index: 900;

  &:hover {
    color: darken($gray-400, 25%);
  }
}

.modal-mask {
  text-indent: 0;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
  @media screen and (max-width: 640px) {
    display: inline;
  }
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  height: 100vh;
  @media screen and (max-width: 640px) {
    display: inline;
  }
}

.modal-container {
  // color: $body-color;
  font-size: 1rem !important;
  max-height: 90vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  width: 60vw;
  max-width: 640px;
  margin: 0px auto;
  padding: 1em;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;

  &.m-dice {
    width: 240px;
    @media screen and (max-width: 640px) {
      margin-top: calc(45vh - 107px);
    }
  }

  &.m-tiny {
    width: 360px;
    max-width: 100%;
  }

  &.m-small {
    width: 40vw;
    max-width: 480px;
  }

  &.m-half {
    width: 50vw;
    max-width: 560px;
  }

  &.m-medium {
    width: 60vw;
    max-width: 640px;
  }

  &.m-large {
    width: 75vw;
    max-width: 800px;
  }

  &.m-x-large {
    width: 80vw;
    max-width: 1024px;
  }

  &.m-full {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 640px) {
    &.m-tiny,
    &.m-small,
    &.m-half,
    &.m-medium,
    &.m-large,
    &.m-full {
      width: 100% !important;
      height: 100vh !important;
      max-height: 100vh !important;
      max-width: 100% !important;
    }
  }
}

.modal-x {
  color: $gray-400;
  font-size: 1.5em;
}

.modal-default-button {
  float: right;
  margin: 0;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.shared-modal-enter {
  opacity: 0;
}

.shared-modal-leave-active {
  opacity: 0;
}
</style>
